<template>
  <div class="agency-event-ranking-header">
    <div v-if="eventInfo">
      <!-- ヘッダー画像 -->
      <banner
        v-if="eventInfo.headerUrl"
        :url="eventInfo.headerUrl"
        :closed="isEventClosed"
        :beginAt="eventInfo.startAt"
        :endAt="eventInfo.endAt"
        :countdownBackgroundBaseColor="'#F8F8F8'"
        :isUserScoring="false"
        :hasEntered="false"
        :bannerFontColor="'#0f0f0f'"
      />
      
      <!-- イベント情報 -->
      <div class="event-header__content">
        <!-- イベント名 -->
        <h1 class="event-header__title">{{ eventInfo.name }}</h1>
        
        <!-- 開催期間 -->
        <div class="event-header__period">
          <img class="event-header__period-icon" src="/img/icon-calendar.svg" />
          {{ formatEventPeriod(eventInfo.startAt, eventInfo.endAt) }}
        </div>
        
        <!-- イベント詳細 -->
        <div v-if="eventInfo.description" class="event-header__description">
          {{ eventInfo.description }}
        </div>

        <!-- 免責事項 -->
        <div v-if="eventInfo.isDisplayDisclaimer" class="event-header__disclaimer">
          {{ $t('agencyEventDisclaimerText') }}
        </div>

        <!-- グループ内スコア無効化の注意文言 -->
        <div v-if="shouldShowGroupInnerScoreText" class="event-header__group-inner-score-notice">
          {{ $t('agencyEventGroupInnerScoreNotice') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import Banner from '@/components/Banner.vue'
import { formatEventPeriod } from '@/utils/time'

export default {
  name: 'AgencyEventRankingHeader',
  components: {
    Banner,
  },
  props: {
    eventInfo: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isEventClosed() {
      if (!this.eventInfo || !this.eventInfo.endAt) {
        return false
      }
      const now = dayjs()
      const endAt = dayjs(this.eventInfo.endAt)
      return now.isAfter(endAt)
    },
    shouldShowGroupInnerScoreText() {
      return this.eventInfo && this.eventInfo.isGroupInnerScoreDisabled
    },
  },
  methods: {
    formatEventPeriod,
  },
}
</script>

<style scoped>
.agency-event-ranking-header {
  max-width: 500px;
  margin: 0 auto;
  background-color: #ffffff;
}

.event-header {
  border-bottom: 1px solid #eeeeee;
}

.event-header__image {
  width: 100%;
  overflow: hidden;
}

.event-header__image img {
  width: 100%;
  height: auto;
  display: block;
}

.event-header__content {
  padding: 16px;
}

.event-header__title {
  font-size: 18px;
  font-weight: bold;
  color: #262626;
  margin: 0 0 8px 0;
  line-height: 1.4;
}

.event-header__period {
  font-size: 14px;
  color: #666666;
  margin-bottom: 12px;
  line-height: 1.4;
  display: flex;
  align-items: center;
}

.event-header__period-icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  vertical-align: middle;
}

.event-header__description {
  font-size: 14px;
  color: #262626;
  line-height: 1.6;
  word-wrap: break-word;
  white-space: pre-line;
  margin-bottom: 6px;
}

.event-header__disclaimer {
  font-size: 12px;
  color: #999999;
  line-height: 1.5;
  white-space: pre-line;
  margin-top: 12px;
}

.event-header__group-inner-score-notice {
  font-size: 12px;
  color: #999999;
  line-height: 1.5;
  white-space: pre-line;
  margin-top: 12px;
}
</style>
